/* tslint:disable:no-inferrable-types */

import { Injectable } from '@angular/core';

@Injectable()
export class PasswordStrengthService {

  getStrength(value): any {
    let score = this.getPasswordStrength(value);
    let label = void (0);
    let color = 'red';
    if (score < 30) {
    } else if (score >= 30 && score < 80) {
      color = 'orange';
    } else if (score >= 80) {
      color = '#6ec02a';
    }
    return {
      score: score,
      label: label,
      color: color
    };
  }

  private getPasswordStrength(str: string): number {
    let grade: number = 0;
    let val;

    val = str.match('[0-9]');
    grade += this.normalize(val ? val.length : 1 / 4, 1) * 25;

    val = str.match('[a-zA-Z]');
    grade += this.normalize(val ? val.length : 1 / 2, 3) * 10;

    val = str.match('[!@#$%^&*?_~.,;=]');
    grade += this.normalize(val ? val.length : 1 / 6, 1) * 35;

    val = str.match('[A-Z]');
    grade += this.normalize(val ? val.length : 1 / 6, 1) * 30;

    grade *= str.length / 8;

    return grade > 100 ? 100 : grade;
  }

  private normalize(x, y): number {
    let diff = x - y;

    if (diff <= 0) {
      return x / y;
    }    else {
      return 1 + 0.5 * (x / (x + y / 4));
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/services/form.validations/password.strength.service.ts